export const getRoutesFlatten = (routes) => {
    if (!Array.isArray(routes)) {
        if (!routes.children) {
            return routes;
        }
        else {
            return getRoutesFlatten(routes.children);
        }
    }

    return routes.reduce((acc, route) => {
        const subRoutes = getRoutesFlatten(route);

        return [ ...acc, ...Array.isArray(subRoutes) ? subRoutes : [ subRoutes ]];
    }, []);
};
